// extracted by mini-css-extract-plugin
module.exports = {"containerImg":"bannerSection_containerImg__C49mA"};